import axios from "axios";

import {
    GET_CHECKLIST_IMPORT_FORMS,
    IMPORT_CHECKLIST_FROM_FORM,
} from "@/utils/constants/constants";

export default {
    data: () => ({
        import_source_form_id: "",
        importable_forms: [],
        is_loading_import_forms: false,
        is_importing_checklist: false,
    }),

    mounted() {
        this.load_importable_forms();
    },

    methods: {
        get_importable_forms_from_response(response) {
            const form_data = response.data;
            const forms = form_data?.status === "success" ? (form_data?.data || []) : [];
            const filtered_forms = forms.filter(
                (form) => Number(form?.id) !== Number(this.form_id)
            );
            return filtered_forms;
        },

        load_importable_forms() {
            if (!this.form_id) {
                this.importable_forms = [];
                return;
            }

            this.is_loading_import_forms = true;

            axios.get(GET_CHECKLIST_IMPORT_FORMS, {
                headers: this.headers,
                params: { target_form_id: this.form_id },
            })
                .then((response) => {
                    this.importable_forms = this.get_importable_forms_from_response(response);
                })
                .catch((error) => {
                    this.show_error("Failed to load importable forms: " + error.message);
                    this.importable_forms = [];
                })
                .finally(() => {
                    this.is_loading_import_forms = false;
                });
        },

        open_import_checklist_modal() {
            this.import_source_form_id = "";
            this.load_importable_forms();
        },

        confirm_import_checklist() {
            if (!this.import_source_form_id) {
                this.show_info("Please select a form to import from.");
                return;
            }

            this.show_confirm(
                "Import checklist",
                "This will create checklist items from the selected form without removing your existing checklist setup.",
                () => this.import_checklist_from_form()
            );
        },

        post_import_checklist_request() {
            const request_payload = {
                target_form_id: this.form_id,
                source_form_id: this.import_source_form_id,
            };
            const request_config = { headers: this.headers };
            const request_promise = axios.post(
                IMPORT_CHECKLIST_FROM_FORM,
                request_payload,
                request_config
            );
            return request_promise;
        },

        handle_import_checklist_success(response) {
            const response_data = response.data;
            const is_success = response_data?.status === "success";

            if (!is_success) {
                throw new Error(response_data?.message || "Failed to import checklist.");
            }

            this.close_modal("import_checklist_modal");
            this.import_source_form_id = "";
            const refresh_promise = this.get_form_sections_with_sections()
                .then(() => {
                    this.show_success(
                        response_data?.message || "Checklist imported successfully."
                    );
                });
            return refresh_promise;
        },

        handle_import_checklist_error(error) {
            const error_message = error.response?.data?.message || error.message;
            this.show_error("Failed to import checklist: " + error_message);
        },

        import_checklist_from_form() {
            this.is_importing_checklist = true;
            let active_loader = null;

            this.fetch_csrf_token()
                .then(() => this.show_loader("Importing checklist..."))
                .then((loader_instance) => {
                    active_loader = loader_instance;
                    return this.post_import_checklist_request();
                })
                .then((response) => this.handle_import_checklist_success(response))
                .catch((error) => this.handle_import_checklist_error(error))
                .finally(() => {
                    this.is_importing_checklist = false;
                    this.close_loader(active_loader);
                });
        },
    },
};
